/**
 * AANKH - Application Entry Point
 * 
 * @author Harshit Khemani
 * @version 1.2.0
 * @description Main entry point for the AANKH React application
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Mount React application
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
